/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {NoteId, NoteInput} from "../__ignore/schemas";

/**
 * @summary Edit lead note
 */
export const EditLeadNoteBody = NoteInput;

export const EditLeadNoteResponse = zod.void();

/**
 * @summary Remove lead note
 */
export const RemoveLeadNoteResponse = zod.void();

/**
 * @summary Add lead note
 */
export const AddLeadNoteBody = NoteInput;

export const AddLeadNoteResponse = NoteId;
